"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _excluded = ["type"];
var TextSkeletonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBLoadingSkeleton__TextSkeletonWrapper",
  componentId: "sc-szw823-0"
})(["display:flex;flex-direction:column;gap:4px;"]);
function TextSkeleton(_ref) {
  var _ref$numOfLines = _ref.numOfLines,
    numOfLines = _ref$numOfLines === void 0 ? 3 : _ref$numOfLines;
  var lines = Array.from({
    length: numOfLines
  }, function (_, i) {
    return /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
      key: i,
      width: "".concat(Math.floor(Math.random() * (100 - 80 + 1)) + 80, "%")
    });
  });
  return /*#__PURE__*/_react["default"].createElement(TextSkeletonWrapper, null, lines);
}
var ImageAndTitleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBLoadingSkeleton__ImageAndTitleWrapper",
  componentId: "sc-szw823-1"
})(["display:flex;align-items:center;gap:6px;"]);
var ImageTitleTextSkeletonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBLoadingSkeleton__ImageTitleTextSkeletonWrapper",
  componentId: "sc-szw823-2"
})(["display:flex;flex-direction:column;gap:6px;"]);
function ImageTitleTextSkeleton(_ref2) {
  var numOfLines = _ref2.numOfLines;
  return /*#__PURE__*/_react["default"].createElement(ImageTitleTextSkeletonWrapper, null, /*#__PURE__*/_react["default"].createElement(ImageAndTitleWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    circle: true,
    height: 50,
    width: 50
  }), /*#__PURE__*/_react["default"].createElement(_reactLoadingSkeleton["default"], {
    width: 150
  })), /*#__PURE__*/_react["default"].createElement(TextSkeleton, {
    numOfLines: numOfLines
  }));
}
var HBLoadingSkeleton = function HBLoadingSkeleton(props) {
  var type = props.type,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  switch (type) {
    case 'image_title_and_text':
      return /*#__PURE__*/_react["default"].createElement(ImageTitleTextSkeleton, {
        numOfLines: rest.numOfLines
      });
    default:
      return /*#__PURE__*/_react["default"].createElement(TextSkeleton, {
        numOfLines: rest.numOfLines
      });
  }
};
var _default = exports["default"] = HBLoadingSkeleton;
//# sourceMappingURL=HBLoadingSkeleton.js.map